export const GetObjectById = (fieldId, data, value) => {
    return data.find(x => 
        String(x[fieldId]).toUpperCase() === String(value).toUpperCase()
    );
};
